import {styled, Button, Box} from '@mui/material';
import {TbHandClick} from 'react-icons/tb';

const CircularButton = styled(Button)<any>(props => ({
  borderRadius: '100px',
  padding: '5px',
  // maxWidth: props.width,
  fontSize: props.theme.typography.pxToRem(20),
  minWidth: 'unset',
  ...(props.size === 'small' && {
    padding: '5px',
    fontSize: props.theme.typography.pxToRem(20),
  }),
}));

const Label = styled('p')<any>(props => ({
  fontSize: props.theme.typography.pxToRem(9),
  margin: '2px 0 0 0',
}));
const Component = (props: any) => (
  <Box
    sx={{
      display: 'inline-block',
      textAlign: 'center',
    }}
  >
    <CircularButton {...props}>{props.icon || <TbHandClick />}</CircularButton>
    <Label>{props.label || props.children}</Label>
  </Box>
);

export default Component;
